import React, {useEffect, useRef} from 'react'
import {useLocation} from 'react-router-dom'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import {useCurrentBasket} from '@salesforce/retail-react-app/app/hooks/use-current-basket'
import {
    hasPendingCheckoutReturn,
    isCheckoutReturnPath,
    resolveCheckoutReturnNavigation
} from '../../../utils/checkout-return-utils'

/**
 * Replays checkout return when the shopper becomes registered without using /login or SSO
 * (e.g. email verification link lands on home/account with an active session).
 * Skips /login and /sso-callback — those paths consume the cookie themselves.
 * Waits for basket; sends to /cart if the flag is set but the basket has no line items.
 */
const PendingCheckoutReturn = () => {
    const {data: customer} = useCurrentCustomer()
    const {data: basket, isSuccess: isBasketSuccess} = useCurrentBasket()
    const location = useLocation()
    const navigate = useNavigation()
    const handledRef = useRef(false)

    useEffect(() => {
        if (typeof window === 'undefined') return
        if (!customer?.isRegistered) return
        if (handledRef.current) return
        if (location.pathname.includes('/sso-callback')) return
        if (location.pathname.endsWith('/login')) return
        if (hasPendingCheckoutReturn() && !isBasketSuccess) return

        const returnRoute = resolveCheckoutReturnNavigation(basket)
        if (!returnRoute) return

        handledRef.current = true

        if (returnRoute === '/checkout' && isCheckoutReturnPath(location.pathname)) {
            return
        }

        navigate(returnRoute)
    }, [customer?.isRegistered, location.pathname, navigate, isBasketSuccess, basket])

    return null
}

export default PendingCheckoutReturn
